var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        /* jshint esversion: 6 */
        var HotOffersRenderer = require('./hot-offers-renderer');

        var HotOffersPage = function () {
            function HotOffersPage(params) {
                var _this = this;

                _classCallCheck(this, HotOffersPage);

                this.source = params.source || 'direct-entry';
                this.desktop = params.isDesktop;
                this.location = params.location || '';
                this.renderer = new HotOffersRenderer(params);
                this.filters = { departCityId: String(params.cityId || ''), countryIds: String(params.countryId || ''), budget: '' };
                this.requests = {};
                this.versions = { filters: 0, offers: 0 };
                this.pendingRequests = 0;
                this.containers = { filters: document.getElementById('hot-offer-filters'), offers: document.getElementById('hot-offers-list') };
                this.skeletons = { filters: this.containers.filters.innerHTML, offers: this.containers.offers.innerHTML };
                this.loaderEl = document.getElementById('hot-offers-loader');
                this.templates = {};
                ['reminder', 'subscribe'].forEach(function (name) {
                    var template = document.getElementById("hot-offers-" + name + "-template");
                    _this.templates[name] = template ? template.innerHTML : '';
                });
                this.handlers();
                this.refresh();
                window.brxTracking.sendAnalyticsEvent('hot_deals_listing_page_open', { source: this.source });
            }

            _createClass(HotOffersPage, [{
                key: "handlers",
                value: function handlers() {
                    var _this2 = this;

                    eventDispatcher.on('click', '.js-link-hotel', function (event, target) {
                        var slider = target.querySelector('.hotel-photo-swiper');
                        if (event.target.closest('.hotel-photo-controls')) return;
                        if (slider && slider.hotelPhotoGallery && !slider.hotelPhotoGallery.allowClick) return;
                        eventDispatcher.dispatchEvent('_block-page');
                        window.location.href = target.dataset.url;
                    });
                    eventDispatcher.on('click', '.js-trigger-city-select', function () {
                        var button = document.querySelector('[data-widget-id="hot-offer-city-select"] .ui-select__toggle-label');
                        if (button) button.click();
                    });
                    eventDispatcher.on('click', '.js-hot-offers-retry', function (event, target) {
                        return _this2.load(target.dataset.type);
                    });
                    eventDispatcher.on('ui-select:change', '#hot-offer-filters .ui-select', function (event) {
                        var detail = event.detail || {};
                        var types = { 'hot-offer-city-select': 'city', 'hot-offer-country-select': 'country', 'hot-offer-budget-select': 'budget' };
                        if (!types[detail.widgetId]) return;
                        var value = detail.value || '';
                        window.brxTracking.sendAnalyticsEvent('hot_deals_filter_change', { type: types[detail.widgetId], value: detail.isMultiple ? value ? value.split(',') : [] : value });
                        [['city', 'departCityId'], ['country', 'countryIds'], ['budget', 'budget']].forEach(function (_ref) {
                            var _ref2 = _slicedToArray(_ref, 2),
                                kind = _ref2[0],
                                key = _ref2[1];

                            var input = document.querySelector("[data-widget-id=\"hot-offer-" + kind + "-select\"] .ui-select__toggle-value");
                            if (input) _this2.filters[key] = input.value;
                        });
                        // Invalidate responses immediately, including during the desktop debounce.
                        Object.keys(_this2.requests).forEach(function (type) {
                            _this2.requests[type].abort();
                            _this2.versions[type]++;
                        });
                        _this2.clearOfferBatches();
                        clearTimeout(_this2.filterTimer);
                        if (_this2.desktop) window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
                        _this2.filterTimer = setTimeout(function () {
                            return _this2.refresh(!_this2.desktop);
                        }, _this2.desktop ? 800 : 0);
                    });
                }
            }, {
                key: "refresh",
                value: function refresh() {
                    var scrollToTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

                    this.load('filters');
                    this.load('offers', scrollToTop);
                }
            }, {
                key: "clearOfferBatches",
                value: function clearOfferBatches() {
                    if (this.onOffersScroll) window.removeEventListener('scroll', this.onOffersScroll);
                    this.onOffersScroll = null;
                    if (this.offersFrame != null) window.cancelAnimationFrame(this.offersFrame);
                    this.offersFrame = null;
                    this.offersData = null;
                }
            }, {
                key: "scheduleOfferBatch",
                value: function scheduleOfferBatch() {
                    var _this3 = this;

                    if (!this.offersData || this.offersFrame != null) return;
                    this.offersFrame = window.requestAnimationFrame(function () {
                        _this3.offersFrame = null;
                        if (!_this3.offersData) return;
                        if (_this3.containers.offers.getBoundingClientRect().bottom > window.innerHeight + 600) return;
                        _this3.appendOfferBatch();
                        if (_this3.renderedOffers === _this3.offersData.offers.length) _this3.clearOfferBatches();
                    });
                }
            }, {
                key: "appendOfferBatch",
                value: function appendOfferBatch() {
                    var data = this.offersData;
                    var start = this.renderedOffers;
                    var offers = data.offers.slice(start, start + 6);
                    if (!offers.length) return;
                    var container = this.containers.offers;
                    var lastElement = container.lastElementChild;
                    container.insertAdjacentHTML('beforeend', this.renderer.offers(Object.assign({}, data, { offers: offers }), this.templates, start, data.offers.length));
                    this.renderedOffers += offers.length;
                    if (this.gallery) {
                        var elements = [];
                        var element = lastElement ? lastElement.nextElementSibling : container.firstElementChild;
                        while (element) {
                            var photo = element.querySelector('.hotel-photo-swiper');
                            if (photo) elements.push(photo);
                            element = element.nextElementSibling;
                        }
                        this.gallery.addElements(elements);
                    }
                    container.querySelectorAll('.js-tg-subscribe-banner').forEach(function (link) {
                        link.href = data.subscribeUrl;
                    });
                }
            }, {
                key: "waitForFilterModal",
                value: function waitForFilterModal() {
                    var modal = this.desktop ? null : document.querySelector('.modal2.hot-offer-city-select-modal, .modal2.hot-offer-country-select-modal, .modal2.hot-offer-budget-select-modal');
                    if (!modal) return Promise.resolve();
                    return new Promise(function (resolve) {
                        // afterHide fires immediately before the detached content is restored.
                        modal.addEventListener('afterHide', function () {
                            return setTimeout(resolve, 0);
                        }, { once: true });
                    });
                }
            }, {
                key: "load",
                value: function load(type) {
                    var _this4 = this;

                    var scrollToTop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

                    if (this.requests[type]) this.requests[type].abort();
                    var controller = new AbortController();
                    this.requests[type] = controller;
                    var version = ++this.versions[type];
                    var inputs = Object.assign({}, this.filters);
                    if (this.location) inputs.location = this.location;
                    var expires = new Date(Date.now() + 86400000).toUTCString();
                    document.cookie = "find_form_city_id=" + encodeURIComponent(inputs.departCityId) + "; expires=" + expires + "; path=/";
                    var query = new URLSearchParams(Object.entries(inputs).filter(function (_ref3) {
                        var _ref4 = _slicedToArray(_ref3, 2),
                            value = _ref4[1];

                        return value !== '';
                    }));
                    var container = this.containers[type];
                    var execute = function execute() {
                        if (type === 'offers') {
                            _this4.clearOfferBatches();
                            if (_this4.gallery) _this4.gallery.destroy();
                            _this4.gallery = null;
                            container.innerHTML = _this4.skeletons.offers;
                        }
                        _this4.pendingRequests++;
                        if (_this4.loaderEl) _this4.loaderEl.classList.add('is-active');
                        return fetch("/new/hot-offers/render-" + type + "?" + query, { signal: controller.signal }).then(function (response) {
                            if (!response.ok) throw new Error("HTTP " + response.status);
                            return response.json();
                        })
                        // Restore detached filter content before replacing its original parent.
                        .then(function (data) {
                            return _this4.waitForFilterModal().then(function () {
                                return data;
                            });
                        }).then(function (data) {
                            if (version !== _this4.versions[type]) return;
                            if (type === 'filters') {
                                var slider = container.querySelector('.js-ui-select-slider');
                                if (slider) {
                                    _this4.renderer.updateFilters(container, data);
                                    var swiper = slider.uiSelectSliderInstance && slider.uiSelectSliderInstance.swiper;
                                    if (swiper) swiper.update();
                                } else {
                                    container.innerHTML = _this4.renderer.filters(data);
                                    if (window.uiSelectWidget) window.uiSelectWidget.initState();
                                    if (window.UiSelectSlider) window.UiSelectSlider.initAll(container);
                                }
                            } else {
                                _this4.offersData = data;
                                _this4.renderedOffers = 0;
                                container.innerHTML = data.offers.length ? '' : _this4.renderer.offers(data, _this4.templates);
                                _this4.appendOfferBatch();
                                container.querySelectorAll('.js-tg-subscribe-banner').forEach(function (link) {
                                    link.href = data.subscribeUrl;
                                });
                                _this4.gallery = new HotelCardsPhoto('#hot-offers-list .hotel-photo-swiper', _this4.renderer.labels);
                                window.hotelPhotoLazySwiper = [_this4.gallery];
                                if (_this4.renderedOffers < data.offers.length) {
                                    _this4.onOffersScroll = function () {
                                        return _this4.scheduleOfferBatch();
                                    };
                                    window.addEventListener('scroll', _this4.onOffersScroll, { passive: true });
                                }
                            }
                        }).catch(function (error) {
                            if (error.name === 'AbortError' || version !== _this4.versions[type]) return;
                            return _this4.waitForFilterModal().then(function () {
                                if (version !== _this4.versions[type]) return;
                                console.error("Hot offers " + type + ":", error);
                                container.innerHTML = _this4.renderer.error(type);
                            });
                        }).finally(function () {
                            _this4.pendingRequests--;
                            if (!_this4.pendingRequests && _this4.loaderEl) _this4.loaderEl.classList.remove('is-active');
                        });
                    };
                    if (type === 'offers' && scrollToTop) {
                        return this.waitForFilterModal().then(function () {
                            if (version !== _this4.versions[type]) return;
                            window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
                            return execute();
                        });
                    }
                    return execute();
                }
            }]);

            return HotOffersPage;
        }();

        module.exports = HotOffersPage;
    }, { "./hot-offers-renderer": 2 }], 2: [function (require, module, exports) {
        /* Shared by the mobile and desktop hot-offers pages. All API strings are text. */
        var escapeHtml = function escapeHtml(value) {
            return String(value == null ? '' : value).replace(/[&<>"']/g, function (char) {
                return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char];
            });
        };

        var HotOffersRenderer = function () {
            function HotOffersRenderer(params) {
                _classCallCheck(this, HotOffersRenderer);

                this.desktop = params.isDesktop;
                this.labels = params.labels;
            }

            _createClass(HotOffersRenderer, [{
                key: "filters",
                value: function filters(data) {
                    var _this5 = this;

                    var l = this.labels;
                    var cities = data.filters.departureCities || [];
                    var countries = data.filters.destinationCountries || [];
                    var selected = data.selected;
                    var city = cities.find(function (item) {
                        return item.id === selected.departCityId;
                    }) || cities[0];
                    var cityName = function cityName(item) {
                        return _this5.desktop ? item.nameFrom || item.name : item.name;
                    };
                    var groups = [];
                    cities.forEach(function (item) {
                        var group = groups.find(function (g) {
                            return g.code === item.countryCode;
                        });
                        if (!group) {
                            group = { code: item.countryCode, label: item.countryName, options: [] };
                            groups.push(group);
                        }
                        group.options.push({ value: String(item.id), label: cityName(item), code: item.countryCode });
                    });
                    var country = countries.find(function (item) {
                        return item.id === selected.countryIds[0];
                    });
                    var countryLabel = selected.countryIds.length > 1 ? data.selectedCountriesLabel : country ? country.name : l.allCountries;
                    var budget = data.budgets.find(function (item) {
                        return item.value === selected.budget;
                    });
                    var selects = [this.select('city', l.city, city ? String(city.id) : String(selected.departCityId), city ? cityName(city) : l.city, groups, false), this.select('country', l.countries, selected.countryIds.join(','), countryLabel, [{ options: countries.map(function (item) {
                            return { value: String(item.id), label: item.name, code: item.code, count: item.toursCount, minPrice: item.tourMinPrice, currency: data.currency };
                        }) }], true, l.allCountries), this.select('budget', l.budget, selected.budget, budget ? budget.label : l.anyBudget, [{ options: [{ value: '', label: l.anyBudget }].concat(data.budgets) }], false, l.anyBudget)];
                    var slider = "<div id=\"hotOffersFilters\" class=\"swiper ui-select-slider ui-select-slider--" + (this.desktop ? 'desktop' : 'mobile') + " js-ui-select-slider" + (this.desktop ? ' hot-offer-desktop-filters__slider' : '') + "\"><div class=\"swiper-wrapper\">" + selects.map(function (html) {
                        return "<div class=\"swiper-slide\">" + html + "</div>";
                    }).join('') + "</div></div>";
                    return this.desktop ? "<div class=\"hot-offer-desktop-filters\">" + slider + "</div>" : slider;
                }
            }, {
                key: "updateFilters",
                value: function updateFilters(container, data) {
                    var template = document.createElement('template');
                    template.innerHTML = this.filters(data);
                    ['city', 'country', 'budget'].forEach(function (kind) {
                        var selector = "[data-widget-id=\"hot-offer-" + kind + "-select\"]";
                        var current = container.querySelector(selector);
                        var next = template.content.querySelector(selector);
                        current.querySelector('.ui-select__content-wrapper').innerHTML = next.querySelector('.ui-select__content-wrapper').innerHTML;
                        current.querySelector('.ui-select__toggle-value').value = next.querySelector('.ui-select__toggle-value').value;
                        current.querySelector('.ui-select__toggle-label').textContent = next.querySelector('.ui-select__toggle-label').textContent;
                        var toggle = current.querySelector('.ui-select__toggle');
                        var nextToggle = next.querySelector('.ui-select__toggle');
                        toggle.dataset.defaultValue = nextToggle.dataset.defaultValue;
                        toggle.dataset.defaultLabel = nextToggle.dataset.defaultLabel;
                        if (window.uiSelectWidget) window.uiSelectWidget.syncToggleUi(toggle);
                    });
                }
            }, {
                key: "select",
                value: function select(kind, title, value, label, groups, multiple, defaultLabel) {
                    var _this6 = this;

                    var e = escapeHtml;
                    var id = "hot-offer-" + kind + "-options";
                    var selected = value.split(',');
                    var options = groups.map(function (group) {
                        var html = "<div class=\"ui-select__options\">" + group.options.map(function (option, index) {
                            var inputId = id + "-" + e(option.value) + "-" + index;
                            var flag = option.code ? "<img src=\"/x-assets/img/flags/waving/" + e(encodeURIComponent(option.code)) + ".png\" alt=\"" + e(option.label) + "\">" : '';
                            var countryDesktop = _this6.desktop && kind === 'country';
                            var detail = option.count == null ? '' : countryDesktop ? "<div class=\"tours-info\"><span class=\"min-price\"><small>" + e(_this6.labels.from) + "</small>" + e(Number(option.minPrice).toLocaleString('ru-RU')) + " " + e(option.currency) + "</span></div>" : "<div class=\"tours-info\"><span class=\"tours\">" + e(option.count) + "</span><span class=\"min-price\">" + e(_this6.labels.from) + " " + e(Number(option.minPrice).toLocaleString('ru-RU')) + e(option.currency) + "</span></div>";
                            var optionLabel = countryDesktop ? flag + "<div class=\"country-info\"><span class=\"country-name\">" + e(option.label) + "</span><span class=\"tours\">" + e(_this6.labels.toursCount.replace('{count}', option.count)) + "</span></div>" + detail : "" + e(option.label) + (_this6.desktop && kind === 'city' ? '' : flag) + detail;
                            return "<div class=\"ui-select__option\"><input type=\"" + (multiple ? 'checkbox' : 'radio') + "\" id=\"" + inputId + "\" name=\"" + id + "\" class=\"ui-select__option-value\" data-option-label=\"" + e(option.label) + "\" value=\"" + e(option.value) + "\" " + (selected.includes(String(option.value)) ? 'checked' : '') + "><label class=\"ui-select__option-label\" for=\"" + inputId + "\">" + optionLabel + "</label></div>";
                        }).join('') + "</div>";
                        return group.label ? "<div class=\"ui-select__group\"><div class=\"ui-select__group-label\"><img src=\"/x-assets/img/flags/" + e(encodeURIComponent(group.code)) + ".png\" alt=\"" + e(group.label) + "\">" + e(group.label) + "</div>" + html + "</div>" : html;
                    }).join('');
                    var heading = this.desktop && kind !== 'budget' ? "<div class=\"ui-select__heading\">" + e(kind === 'country' ? this.labels.destination : title) + "</div>" : '';
                    var content = "<div id=\"" + id + "\" class=\"ui-select__content " + (this.desktop ? 'hidden' : '') + "\">" + heading + "<div class=\"ui-select__content-wrapper\">" + options + "</div>" + (multiple ? "<div class=\"ui-select__apply-wrapper\"><button type=\"button\" class=\"ui-select__apply-value\">" + e(this.labels.apply) + "</button></div>" : '') + "</div>";
                    return "<div class=\"ui-select ui-select--" + (this.desktop ? 'desktop' : 'mobile') + "\" data-title=\"" + e(title) + "\" data-modal-css-class=\"hot-offer-" + kind + "-select-modal\" data-widget-id=\"hot-offer-" + kind + "-select\"><div class=\"ui-select__toggle\" data-content-id=\"" + id + "\" data-is-multiple=\"" + (multiple ? '1' : '0') + "\" data-default-label=\"" + e(defaultLabel || label) + "\" data-default-value=\"" + e(defaultLabel ? '' : value) + "\"><button class=\"ui-select__toggle-label\" type=\"button\">" + e(label) + "</button><button type=\"button\" class=\"ui-select__reset hidden\"></button><input type=\"hidden\" class=\"ui-select__toggle-value\" name=\"" + id + "\" value=\"" + e(value) + "\"></div>" + (this.desktop ? content : "<div class=\"hidden\">" + content + "</div>") + "</div>";
                }
            }, {
                key: "offers",
                value: function offers(data) {
                    var templates = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

                    var _this7 = this;

                    var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
                    var total = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : data.offers.length;

                    var e = escapeHtml;
                    if (!data.offers.length) return "<div class=\"hot-offers-not-found\"><div class=\"hot-offers-not-found-content\"><div class=\"title\">" + e(this.labels.emptyTitle) + "</div><div class=\"description\">" + e(this.labels.emptyDescription) + "</div></div>" + (this.desktop ? '' : "<button type=\"button\" class=\"btn-change-depart-city js-trigger-city-select\">" + e(this.labels.changeCity) + "</button>") + "</div>";
                    var subscribe = !this.desktop && data.subscribeUrl ? templates.subscribe || '' : '';
                    return data.offers.map(function (hotel, index) {
                        return _this7.card(hotel) + (!_this7.desktop && offset + index === 0 ? templates.reminder || '' : '') + (offset + index === 4 && total > 5 ? subscribe : '');
                    }).join('') + (total <= 5 && offset + data.offers.length === total ? subscribe : '');
                }
            }, {
                key: "card",
                value: function card(hotel) {
                    var _this8 = this;

                    var e = escapeHtml;
                    var url = e(hotel.tours[0].url);
                    var galleryUrl = e(hotel.url);
                    var stars = hotel.stars ? "<div class=\"hotel-card__class hotel-card__class--default\"><div class=\"class class--" + e(hotel.stars) + "\"></div></div>" : '';
                    var rating = hotel.rating ? "<div class=\"m-rating hotel-card-rating m-rating--booking\"><div class=\"flex\"><img class=\"brand-logo\" src=\"/x-assets/img/logo/logo-booking.svg\" alt=\"Booking\"><div class=\"reviews-count\">" + e(hotel.reviews) + "</div></div><div class=\"rating-value\">" + e(hotel.rating) + "</div></div>" : '';
                    return "<div class=\"hotel-card\"><div class=\"hotel-card__slider js-link-hotel\" data-url=\"" + galleryUrl + "\"><div class=\"swiper hotel-photo-swiper\" data-hotel-id=\"" + e(hotel.id) + "\" data-photos-count=\"" + e(hotel.photosCount) + "\" data-has-more-photos=\"" + (hotel.hasMorePhotos ? '1' : '0') + "\" data-photos-url=\"" + e(hotel.photosUrl) + "\"><div class=\"swiper-wrapper\">" + hotel.photos.map(function (src) {
                        return "<div class=\"swiper-slide\"><img class=\"swiper-lazy\" data-src=\"" + e(src) + "\" alt=\"\"></div>";
                    }).join('') + "</div><div class=\"swiper-pagination\"></div></div>" + (hotel.photosCount > 1 ? "<div class=\"photo-count\">" + e(hotel.photosCount) + "</div>" : '') + "<div class=\"hotel-card__beach\">" + (hotel.seaLine ? "<span class=\"hotel-card__beach-item sea-line\">" + e(hotel.seaLine) + "</span>" : '') + (hotel.beachType ? "<span class=\"hotel-card__beach-item beach\">" + e(hotel.beachType) + "</span>" : '') + (hotel.aquaPark ? "<span class=\"hotel-card__beach-item aquapark\">" + e(this.labels.aquaPark) + "</span>" : '') + "</div></div><div class=\"hotel-card__content js-link-hotel\" data-url=\"" + url + "\"><div class=\"hotel-card__rating-row\"><div class=\"flex\">" + stars + rating + "</div></div><div class=\"hotel-card__name\">" + e(hotel.name) + "</div><div class=\"hotel-card__location\">" + e(hotel.location) + "</div><div class=\"hotel-card__split\"></div></div>" + hotel.tours.map(function (tour, index) {
                        return _this8.tour(tour, index);
                    }).join('') + "</div>";
                }
            }, {
                key: "tour",
                value: function tour(_tour, index) {
                    var e = escapeHtml;
                    var airlines = _tour.airlines.length ? _tour.airlines.map(function (airline) {
                        return "<img src=\"/x-assets/img/airlines/" + e(encodeURIComponent(airline.code)) + ".png\" alt=\"" + e(airline.name) + "\">";
                    }).join('') : "<span class=\"airline-empty\">" + e(this.labels.airlineLater) + "</span>";
                    return "<div class=\"hotel-card__content js-link-hotel\" data-url=\"" + e(_tour.url) + "\">" + (index ? '<div class="hotel-card__split"></div>' : '') + "<div class=\"hotel-card__tour\"><div class=\"hotel-card__tour-info\"><div class=\"tour-info-item dates\">" + e(_tour.dates) + ", <span class=\"hot-offer-adults\">" + e(_tour.adults) + "</span></div><div class=\"tour-info-item meal\">" + e(_tour.meal) + "</div><div class=\"tour-info-item airline\">" + airlines + "</div></div><div class=\"hotel-card__tour-price\"><div class=\"old-price\">" + e(_tour.oldPrice) + "</div><div class=\"current-price\">" + e(_tour.price) + "</div><div class=\"discount\">" + e(_tour.discount) + "</div></div></div></div>";
                }
            }, {
                key: "error",
                value: function error(type) {
                    return "<div class=\"hot-offers-not-found\"><p>" + escapeHtml(this.labels.loadError) + "</p><button type=\"button\" class=\"btn-change-depart-city js-hot-offers-retry\" data-type=\"" + escapeHtml(type) + "\">" + escapeHtml(this.labels.retry) + "</button></div>";
                }
            }]);

            return HotOffersRenderer;
        }();

        module.exports = HotOffersRenderer;
    }, {}], 3: [function (require, module, exports) {
        window.HotOffersPage = require('../../../../common/_parts/hot-offers-page');
    }, { "../../../../common/_parts/hot-offers-page": 1 }] }, {}, [3]);